import {
  TypographyOptions,
  TypographyStyleOptions,
} from '@material-ui/core/styles/createTypography';

const fallbackFamily: TypographyStyleOptions['fontFamily'] =
  '"Helvetica Neue", Helvetica, Arial, "sans-serif"';
const fontFamily: TypographyStyleOptions['fontFamily'] = `CircularXXWeb,${fallbackFamily}`;

/**
 * AXDS `body` typography token defined as MUI `TypographyStyleOptions`
 *
 * @see {@link https://www.figma.com/file/TR4yYLzvYHPznF5zBgyHOA/Applicant-Experience-Design-System?node-id=889%3A16961}
 */
const body: TypographyStyleOptions = {
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: 1.5,
};

/**
 * AXDS `bodyCompact` typography token defined as MUI `TypographyStyleOptions`
 *
 * @see {@link https://www.figma.com/file/TR4yYLzvYHPznF5zBgyHOA/Applicant-Experience-Design-System?node-id=889%3A16961}
 */
const bodyCompact: TypographyStyleOptions = {
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: 1.25,
};

/**
 * AXDS `headingXL` typography token defined as MUI `TypographyStyleOptions`
 *
 * @see {@link https://www.figma.com/file/TR4yYLzvYHPznF5zBgyHOA/Applicant-Experience-Design-System?node-id=889%3A16961}
 */
const headingXL: TypographyStyleOptions = {
  fontSize: '2rem',
  fontWeight: 500,
  lineHeight: 1.25,
};

/**
 * AXDS `headingLG` typography token defined as MUI `TypographyStyleOptions`
 *
 * @see {@link https://www.figma.com/file/TR4yYLzvYHPznF5zBgyHOA/Applicant-Experience-Design-System?node-id=889%3A16961}
 */
const headingLG: TypographyStyleOptions = {
  fontSize: '1.75rem',
  fontWeight: 500,
  lineHeight: 1.285,
};

/**
 * AXDS `headingMD` typography token defined as MUI `TypographyStyleOptions`
 *
 * @see {@link https://www.figma.com/file/TR4yYLzvYHPznF5zBgyHOA/Applicant-Experience-Design-System?node-id=889%3A16961}
 */
const headingMD: TypographyStyleOptions = {
  fontSize: '1.5rem',
  fontWeight: 500,
  lineHeight: 1.333,
};

/**
 * AXDS `headingSM` typography token defined as MUI `TypographyStyleOptions`
 *
 * @see {@link https://www.figma.com/file/TR4yYLzvYHPznF5zBgyHOA/Applicant-Experience-Design-System?node-id=889%3A16961}
 */
const headingSM: TypographyStyleOptions = {
  fontSize: '1.25rem',
  fontWeight: 500,
  lineHeight: 1.4,
};

/**
 * AXDS `headingXS` typography token defined as MUI `TypographyStyleOptions`
 *
 * @see {@link https://www.figma.com/file/TR4yYLzvYHPznF5zBgyHOA/Applicant-Experience-Design-System?node-id=889%3A16961}
 */
const headingXS: TypographyStyleOptions = {
  fontSize: '1rem',
  fontWeight: 500,
  lineHeight: 1.5,
};

/**
 * AXDS `subtitle` typography token defined as MUI `TypographyStyleOptions`
 *
 * @see {@link https://www.figma.com/file/TR4yYLzvYHPznF5zBgyHOA/Applicant-Experience-Design-System?node-id=889%3A16961}
 */
const subtitle: TypographyStyleOptions = {
  fontSize: '0.875rem',
  fontWeight: 400,
  lineHeight: 1.428,
};

/**
 * AXDS `subtitleCompact` typography token defined as MUI `TypographyStyleOptions`
 *
 * @see {@link https://www.figma.com/file/TR4yYLzvYHPznF5zBgyHOA/Applicant-Experience-Design-System?node-id=889%3A16961}
 */
const subtitleCompact: TypographyStyleOptions = {
  fontSize: '0.875rem',
  fontWeight: 400,
  lineHeight: 1.142,
};

/**
 * AXDS typography tokens defined as MUI `TypographyOptions`
 *
 * @see {@link https://www.figma.com/file/TR4yYLzvYHPznF5zBgyHOA/Applicant-Experience-Design-System?node-id=889%3A16961}
 */
export const typography: TypographyOptions = {
  fontFamily,

  body,
  bodyCompact,
  headingXL,
  headingLG,
  headingMD,
  headingSM,
  headingXS,
  subtitle,
  subtitleCompact,

  // Override the MUI base typography tokens to our own
  body1: body,
  body2: { ...subtitle, lineHeight: 1 },
  button: { ...body, lineHeight: 1.75, textTransform: 'none' },
  caption: subtitle,
  h1: headingLG,
  h2: headingMD,
  h3: headingSM,
  h4: headingXS,
  h5: headingXS,
  h6: headingXS,
  subtitle1: subtitle,
  subtitle2: subtitleCompact,
  overline: { ...body, textTransform: 'none' },
};
